import { ContactsModule } from 'modules/v3/Contacts';
import { HomeModule } from 'modules/v3/Home';
import { LiveTrackModule } from 'modules/v3/LiveTrack';
import { MainPreferencesModule } from 'modules/v3/MainPreferences';
import { MechanicalModule } from 'modules/v3/Mechanical';
import { MyAdminModule } from 'modules/v3/MyAdmin';
import { RequestServiceModule } from 'modules/v3/RequestService';
import { TireWheelModule } from 'modules/v3/TireWheel';

export interface V3RouteConfig {
  segment: string;
  label: string;
  component: React.ComponentType<any>;
  sidebar: boolean;
}

/**
 * MSP 3.0 (v3) route definitions.
 * Used by both Routes.tsx (to render routes) and UIVersionContext.tsx
 * (to detect whether the current URL is a v3 route).
 * Add new v3 routes here — both consumers update automatically.
 */
export const V3_ROUTES: V3RouteConfig[] = [
  { segment: 'home', label: 'Home', component: HomeModule, sidebar: true },
  { segment: 'request-service', label: 'Request Service', component: RequestServiceModule, sidebar: true },
  { segment: 'liveTrack', label: 'LiveTrack', component: LiveTrackModule, sidebar: true },
  { segment: 'main-preferences', label: 'Main Preferences', component: MainPreferencesModule, sidebar: true },
  { segment: 'tire-wheel', label: 'Tire & Wheel Preferences', component: TireWheelModule, sidebar: true },
  { segment: 'mechanical', label: 'Mechanical Preferences', component: MechanicalModule, sidebar: true },
  { segment: 'contacts', label: 'Contacts', component: ContactsModule, sidebar: true },
  { segment: 'my-admin', label: 'My Admin Area', component: MyAdminModule, sidebar: true },
];

export const V3_ROUTE_SEGMENTS = V3_ROUTES.map((r) => r.segment);

// Re-export the dependency-free v3 path helpers so existing consumers that import
// from 'V3Routes' keep working.
export { isV3Path, V3_SUB_SEGMENTS, V3_TOP_SEGMENTS } from './v3RouteUtils';
